import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ProjectCard from './ProjectCard';
import justyolImg from '../assets/images/justyol.webp';
import MaykanaImg from '../assets/images/maykana.webp';
import vosmosImg from '../assets/images/vosmos.webp';
import atayaImg from '../assets/images/ataya.webp';
import '../styles/Projects.css';

gsap.registerPlugin(ScrollTrigger);

const projects = [
  {
    title: 'Atayaa Al Rahman Website & ERP',
    description: 'Charity foundation website focused on empowering people with physical disabilities, with ERP-backed join/donation flows and bilingual content.',
    image: atayaImg,
    link: 'https://atayaalrahman.org/',
    tags: ['React', 'ERPNext', 'Python', 'Vite', 'Tailwind CSS']
  },
  {
    title: 'Vosmos Clothing Store',
    description: 'Full-featured Django e-commerce platform with product customization, anonymous shopping, persistent cart, email notifications, and comprehensive order management system.',
    image: vosmosImg,
    link: 'https://vosmos.pythonanywhere.com',
    tags: ['Django', 'Python', 'E-commerce', 'CSS']
  },
  {
    title: 'Justyol - E-commerce Integration Platform',
    description: 'Advanced integration system connecting Shopify with ERPNext, featuring Aramex and Cathedis shipping integrations with extensive customizations for streamlined order fulfillment and inventory management.',
    image: justyolImg,
    link: 'https://justyol.com',
    tags: ['ERPNext', 'Shopify', 'API Integration', 'Python']
  },
  {
    title: 'ZATCA Phase 2 Integration with ERPNext',
    description: 'Comprehensive integration of Saudi Tax Authority (ZATCA) Phase 2 requirements with ERPNext, implementing e-invoicing compliance, real-time invoice reporting, and automated tax validation for Saudi Arabian businesses.',
    image: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    link: 'https://github.com/momenmedhatsalem',
    tags: ['ERPNext', 'ZATCA', 'Tax Compliance', 'API Integration']
  },
  {
    title: 'Triple Gates - ERPNext UI Redesign',
    description: 'Complete UI/UX overhaul for ERPNext platform, creating a modern, intuitive interface with enhanced usability, streamlined workflows, and improved user experience for better productivity.',
    image: MaykanaImg,
    link: 'https://github.com/momenmedhatsalem',
    tags: ['Frappe', 'ERPNext', 'UI/UX', 'JavaScript']
  },
  {
    title: 'ERP SaaS Automation Platform',
    description: 'Fully automated ERP provisioning system that streamlines client registration and instantly deploys ready-to-use ERPNext sites without human intervention, enabling seamless SaaS delivery.',
    image: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    link: 'https://github.com/momenmedhatsalem',
    tags: ['Python', 'Frappe', 'ERPNext', 'JavaScript']
  },
  {
    title: 'Camelo - Airport Transportation App',
    description: 'Complete airport transportation solution with backend built entirely on ERPNext. Features payment gateway integrations, real-time push notifications, and webhook-based event handling for seamless operations.',
    image: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    link: 'https://github.com/momenmedhatsalem',
    tags: ['ERPNext', 'Python', 'Payment Integration', 'Webhooks']
  }
];

const Projects = () => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const cardsRef = useRef(null);

useEffect(() => {
  const ctx = gsap.context(() => {
    gsap.from(titleRef.current, {
      y: 60,
      autoAlpha: 0,
      duration: 0.8,
      ease: 'power3.out',
      immediateRender: false,
      scrollTrigger: {
        trigger: sectionRef.current,
        start: 'top bottom',
        toggleActions: 'play none none reverse'
      }
    });

    gsap.from(cardsRef.current.children, {
      y: 80,
      autoAlpha: 0,
      scale: 0.9,
      stagger: 0.15,
      duration: 0.7,
      ease: 'power3.out',
      immediateRender: false,
      scrollTrigger: {
        trigger: cardsRef.current,
        start: 'top bottom',
        toggleActions: 'play none none reverse'
      }
    });
  }, sectionRef);

  return () => ctx.revert();
}, []);

  return (
    <section ref={sectionRef} className="projects" id="projects">
      <div className="projects-container">
        <h2 ref={titleRef} className="projects-title">
          Featured Projects
        </h2>

        <div ref={cardsRef} className="projects-grid">
          {projects.map((project, index) => (
            <ProjectCard
              key={index}
              {...project}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
